import { FontIcon } from 'office-ui-fabric-react';
import * as React from 'react';

import { LinkTarget } from '../shared/constants/link-target.enum';
import { OfficeRoute } from '../shared/constants/office-route.enum';
import { InstrumentationService, KnownInstrumentationEvents } from '../shared/instrumentation/instrumentation.service';
import { LocService } from '../shared/shared-context/loc.service';
import { ReactShellConfigService } from '../shared/shared-context/react-shell-config.service';

export interface MeetNowButtonReactComponentProps {
    readonly locService: LocService;
    readonly instrumentationService: InstrumentationService;
    readonly reactShellConfigService: ReactShellConfigService;
    readonly route: OfficeRoute;
    readonly linkTarget: LinkTarget;
}

export default !React
    ? () => null
    : class MeetNowButtonComponent extends React.Component<MeetNowButtonReactComponentProps> {
        constructor(props: MeetNowButtonReactComponentProps) {
            super(props);
        }

        public render() {
            this.props.instrumentationService.logImpressionEvent(KnownInstrumentationEvents.MeetNowButtonImpression);
            const meetNowIconName = this.props.route === OfficeRoute.OfficeHome || this.props.route === OfficeRoute.Pwa || this.props.route === OfficeRoute.AppGallery || this.props.route === OfficeRoute.Search ? 'meetNowIcon' : 'meetNowIconWhite';

            return (
                <a id='meet-now-button'
                style={{ lineHeight: 'normal' }}
                className='meet-now-button o365sx-button o365sx-highContrastButton'
                href={this.props.reactShellConfigService.reactShellConfig.meetNowLinkUrl}
                target={this.props.linkTarget}
                title={this.props.locService.MeetNowButtonLabel}
                aria-label={this.props.locService.MeetNowButtonLabel}>
                    <FontIcon iconName={meetNowIconName} />
                </a>
            );
        }
    };
